// extracted by mini-css-extract-plugin
export default {"promoCodeClass":"_3b9645c5","promoWrapper":"_be92c275"};